import DirectionModalTasks from './direction-modal-tasks'

export default DirectionModalTasks
